document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector(".popup");

    if( modal ){
        const modalContent = document.querySelector(".popup .popup__content");
        const isExitModal = modal.classList.contains('isExitPopup');
        const isScrollModal = modal.classList.contains('isScrollPopup');

        if(modal && modalContent){
            const modalDelay = modal.dataset.delay;

            if( !isExitModal && !isScrollModal ){
                if(modalDelay !== undefined){
                    let modalDelayTime = parseInt(modalDelay);

                    if(modalDelayTime > 0){
                        let waitPeriod = false;

                        const interval = setInterval(() => {
                            if(waitPeriod){
                                modal.style.display = "flex";
                                clearInterval(interval);
                            }

                            setTimeout(() => {
                                waitPeriod = true;
                            }, modalDelayTime);
                        }, 500);
                    }
                }else{
                    modal.style.display = "flex";
                }
            }

            if( isExitModal ){
                modal.style.display = "none";

                window.addEventListener('mouseout', (e) => {
                    if (e.clientY < 50) {
                        let modalDelayTime = parseInt(modalDelay);

                        if(modalDelayTime > 0){
                            let waitPeriod = false;

                            const interval = setInterval(() => {
                                if(waitPeriod){
                                    modal.style.display = "flex";
                                    clearInterval(interval);
                                }

                                setTimeout(() => {
                                    waitPeriod = true;
                                }, modalDelayTime);
                            }, 500);
                        }else{
                            modal.style.display = "flex";
                        }
                    }
                });
            }

            if( isScrollModal ){
                modal.style.display = "none";

                window.addEventListener("scroll", function () {
                    var scrollPosition = window.scrollY;

                    if (scrollPosition > 500) {
                        modal.style.display = "flex";
                    }
                });
            }

            document.querySelector(".popup__content--close-btn")?.addEventListener('click', () => modal.style.display = "none");

            window.addEventListener('click', (event) => {
                if (event.target == modal) {
                    modal.style.display = "none";
                }
            });
        }
    }
});